import { DateTime } from 'luxon';

export interface KioskBookingData {
  booking_uuid: string;
  diary_uuid: string;
  practice_uuid: string;
  booking_date_time: string;
  user_surname: string;
  user_name: string;
  user_cellnr: string;
  user_dob: string;
  diary_name: string;
  practice_name: string;
  user_email?: string;
}

export class KioskBooking {
  bookingUuid: string;
  diaryUuid: string;
  practiceUuid: string;
  bookingDateTime: DateTime;
  userSurname: string;
  userName: string;
  userCellnr: string;
  userDob: DateTime;
  diaryName: string;
  practiceName: string;
  userEmail: string;

  constructor(data: KioskBookingData) {
    this.bookingUuid = data.booking_uuid;
    this.diaryUuid = data.diary_uuid;
    this.practiceUuid = data.practice_uuid;
    this.bookingDateTime = DateTime.fromISO(data.booking_date_time);
    this.userSurname = data.user_surname;
    this.userName = data.user_name;
    this.userCellnr = data.user_cellnr;
    this.userDob = DateTime.fromISO(data.user_dob);
    this.diaryName = data.diary_name;
    this.practiceName = data.practice_name;
    this.userEmail = data.user_email;
  }
}
